export type Theme = "light" | "dark";

// Shared with the marketing admin (api.zerotoclaw.ai) so both admins open in
// the same theme. Only ever "light" or "dark"; anything else is ignored.
export const THEME_COOKIE = "ztc_theme";
const SHARED_DOMAIN = "zerotoclaw.ai";
const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365;

export const readThemeCookie = (cookieHeader: string): Theme | null => {
  for (const part of cookieHeader.split(";")) {
    const [name, value] = part.trim().split("=");
    if (name === THEME_COOKIE && (value === "light" || value === "dark")) return value;
  }
  return null;
};

export const themeCookie = (theme: Theme, hostname: string, secure: boolean): string => {
  const shared = hostname === SHARED_DOMAIN || hostname.endsWith(`.${SHARED_DOMAIN}`);
  return [
    `${THEME_COOKIE}=${theme}`,
    "Path=/",
    `Max-Age=${ONE_YEAR_SECONDS}`,
    "SameSite=Lax",
    ...(shared ? [`Domain=${SHARED_DOMAIN}`] : []),
    ...(secure ? ["Secure"] : []),
  ].join("; ");
};
